import { ImageOptions } from "core/components";
export function getImages(image) {
    return [
        // 1920 & 1920 x2
        {
            urls: image.large,
            options: ImageOptions.fitWidth(3840),
            srcWidth: "3840w",
            query: "",
        },
        {
            urls: image.large,
            options: ImageOptions.fitWidth(1920),
            srcWidth: "1920w",
            query: "",
        },
        // 1280 & 1280 x2
        {
            urls: image.medium,
            options: ImageOptions.fitWidth(2560),
            srcWidth: "2560w",
            query: "",
        },
        {
            urls: image.medium,
            options: ImageOptions.fitWidth(1280),
            srcWidth: "1280w",
            query: "",
        },
        // 1024 & 1024 x2
        {
            urls: image.medium,
            options: ImageOptions.fitWidth(2048),
            srcWidth: "2048w",
            query: "",
        },
        {
            urls: image.medium,
            options: ImageOptions.fitWidth(1024),
            srcWidth: "1024w",
            query: "",
        },
        // 480 & 480 x2
        {
            urls: image.small,
            options: ImageOptions.fitWidth(960),
            srcWidth: "960w",
            query: "",
        },
        {
            urls: image.small,
            options: ImageOptions.fitWidth(480),
            srcWidth: "480w",
            query: "",
        },
        // Fallback Image with 100vw query
        {
            urls: image.small,
            options: ImageOptions.fitWidth(2048),
            srcWidth: "2048w",
            query: "100vw",
        },
    ];
}
